import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="读者反馈"
          title="读完以后，他们多问了一句话"
          desc="以下内容来自读者来信节选，已做匿名处理。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className={`flex flex-col p-5 md:p-7 rounded-lg border ${
                index === 0
                  ? "bg-primary-50 border-primary-200"
                  : "bg-background-50 border-background-200"
              }`}
            >
              <i
                className="ri-double-quotes-l text-3xl text-primary-400 mb-4"
                aria-hidden="true"
              ></i>
              <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 font-heading text-base">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}